export default __webpack_public_path__ + "assets/img/shopping-cart.svg";